import moment from 'moment';

export const collectionFilter = (itemsCollection, keysArray, value) => {
	const lowerCaseValue = value.toLowerCase();
	const keysLength = keysArray.length;

	return itemsCollection.filter((item) => {
		for(let i = 0; i < keysLength; i += 1) {
			if(item[keysArray[i]] && item[keysArray[i]].toString().toLowerCase().includes(lowerCaseValue)) {
				return true;
			}
		}
		return false;
	});
};

export const ucFirst = (text) => {
	return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
};

export const formatDate = (date, format = 'MMM D, YYYY') => {
	return moment(date).format(format);
};

export const formatDuration = (start, end) => {
	const duration = moment.duration(moment(end).diff(moment(start)));
	let message = "";
	if (duration.days() > 0) message +=  duration.days() + 'd ';
	if (duration.hours() > 0) message +=  duration.hours() + 'h ';
	if (duration.minutes() > 0) message +=  duration.minutes() + 'm';
	return message;
};

export const arrayToObject = (array, keyField) => {
	return array.reduce((obj, item) => {
		obj[item[keyField]] = item;
		return obj;
	}, {});
};

export const groupBy = (array, key, key2 = null) => {
	if(key2) {
		return array.reduce((accumulator, item) => {
			accumulator[item[key]] = accumulator[item[key]] || {};
			accumulator[item[key]][item[key2]] = accumulator[item[key]][item[key2]] || [];
			accumulator[item[key]][item[key2]].push(item);
			return accumulator;
		}, {});
	}
	else {
		return array.reduce((accumulator, item) => {
			accumulator[item[key]] = accumulator[item[key]] || [];
			accumulator[item[key]].push(item);
			return accumulator;
		}, {});
	}
};

export const arrayMergeUnique = (arr1, arr2, arr3 = []) => {
	const hash = {};
	return arr1.concat(arr2, arr3).filter(val => (hash[val] ? 0 : hash[val] = 1 ))
};

export const isSystemAdmin = (userSession) => {
	return userSession.active_role_type === 'System Admin';
};

export const isRegionUser = (userSession) => {
	return userSession.active_role_type === 'Region User';
};

export const isBusinessUnitUser = (userSession) => {
	return userSession.active_role_type === 'Business Unit User';
};

export const isCustomerUser = (userSession) => {
	return userSession.active_role_type === 'Customer User';
};

export const isLocationCustomer = (userSession) => {
	return userSession.active_role_id === 6;
};

export const isTeamMember = (userSession) => {
	return userSession.active_role_id === 9;
};

export const isStationManager = (userSession) => {
	return userSession.active_role_id === 10;
};

export const isStationOperator = (userSession) => {
	return userSession.active_role_id === 11;
};

export const formatNumber = (number) => {
	if (number === undefined || number === null) return null;
	return number.toLocaleString("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 2 });
};

export const formatAmount = (amount, currency='$') => {
	if (amount === undefined || amount === null) return null;
	return `${currency}${formatNumber(amount)}`;
};
